
    var riot = require('riot')
    riot.tag2('comment-feedback-modal-abort', '<div class="messaging-modal-body"> <div class="messaging-modal-body-icon"> <span class="warning--before"></span> </div> <h2 class="messaging-modal-title text-center">Säker på att du vill avbryta?</h2> <p class="messaging-modal-text text-center">Om du avbryter kommer din kommentar inte att sparas.</p> <button class="secondary-action messaging-modal-message-action" onclick="{onClose}">Ja avbryt</button> <button class="default-action messaging-modal-message-action" onclick="{onRetry}">Nej fortsätt skriva</button> </div>', '', '', function(opts) {
        this.onClose = function () {
            this.bus.trigger('ui:comment-feedback-modal-abort:on-close');
        }.bind(this);

        this.onRetry = function () {
            this.bus.trigger('ui:comment-feedback-modal-abort:on-retry', null);
        }.bind(this);
});


    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-abort.riot.html